CustomTC.define('modules/chapters/chapter',['modules/util', 'modules/core', 'modules/config'], function(util, core, config) {
    return {
    	chapterTime: 0,
    	chapterClick: 0,
        // get chapter time
        getChapterTime: function() {
        	return this.chapterTime;
        },
        // set chapter time
        setChapterTime: function(time) {
        	this.chapterTime = time;
        },
        //get chapter click
        getChapterClick: function() {
        	return this.chapterClick;
        },
        //set chapter click
        setChapterClick: function(click) {
        	this.chapterClick = click;
        }
    };
});
